module.exports = __webpack_public_path__ + "img/icon-floorplans.57df447b.svg";